<template>
  <v-dialog v-model="dialog" @keydown.esc="cancel" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-container class="mt-4 px-8 border-with-title">
            <div class="border-title-parent">
              <div class="border-title">施設状況</div>
            </div>
            <v-row>
              <v-col cols="6">
                <v-textarea
                  :value="item.fa_name"
                  label="施設名"
                  v-bind="formControlProps"
                  rows="2"
                >
                </v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  v-model="item.fa_address"
                  label="施設住所"
                  v-bind="formControlProps"
                  rows="2"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-textarea
                  :value="item.fa_name_kana"
                  label="施設名（カナ）"
                  v-bind="formControlProps"
                  rows="2"
                >
                </v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  v-model="item.fa_name_en"
                  label="施設名（英名）"
                  v-bind="formControlProps"
                  rows="2"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="開設状況"
                  :value="$facility.openingStatusName(item)"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  label="開設日時"
                  :value="formatDatetime(item.opening_date)"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="閉鎖日時"
                  :value="formatDatetime(item.closing_date)"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <template v-if="facilityClass.isShelter()">
              <v-row dense>
                <v-col class="caption search-item-caption">
                  ライフライン状況
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="3"
                  v-for="(label, key, index) in $facility.lifelines"
                  :key="index"
                >
                  <v-text-field
                    :label="label"
                    v-bind="formControlProps"
                    :value="$facility.lifelineStatusName(item, key)"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    label="避難者数"
                    :value="item.seating_capacity"
                    suffix="人"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="現在の避難者数"
                    :value="item.current_seating_capacity"
                    suffix="人"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="避難者数のうちQRコード登録者"
                    :value="item.qr_enter_num"
                    suffix="人"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    label="現在の避難者世帯数"
                    :value="item.seating_household"
                    suffix="世帯"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    label="退所者数"
                    :value="item.exit_num"
                    suffix="人"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="退所者数のうちQRコード登録者"
                    :value="item.qr_exit_num"
                    suffix="人"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-if="facilityClass.isInspection()">
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    label="到着済人数"
                    :value="item.arrival_num"
                    suffix="人"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    label="検査済バス車両数"
                    :value="item.bus_num"
                    suffix="台"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    label="検査済バス車両数のうちバス検査不合格数"
                    :value="item.bus_insp_ngnum"
                    suffix="台"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    label="検査済乗用車数"
                    :value="item.car_num"
                    suffix="台"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    label="検査済乗用車数のうち乗用車検査不合格数"
                    :value="item.car_insp_ngnum"
                    suffix="台"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-if="facilityClass.isInspection()">
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    label="混雑状況"
                    :value="$facility.congestionSituationName(item)"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </template>
            <v-row>
              <v-col cols="6">
                <v-textarea
                  v-model="item.free_input"
                  label="備考"
                  readonly
                  placeholder=" "
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>

          <v-container class="mt-16 px-8 border-with-title">
            <div class="border-title-parent">
              <div class="border-title">施設基本情報</div>
            </div>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="原子力防災施設区分"
                  :value="facilityClass.name()"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <template v-if="facilityClass.isInspection()">
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    v-model="item.lanes"
                    label="レーン数"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="item.max_capacity"
                    label="最大収容人数"
                    suffix="人"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="item.max_household"
                    label="最大収容世帯数"
                    suffix="世帯"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </template>
            <v-row>
              <template v-if="facilityClass.isShelter()">
                <v-col cols="3">
                  <v-text-field
                    label="指定区分"
                    :value="$facility.designatedCategoryName(item)"
                    v-bind="formControlProps"
                  >
                  </v-text-field>
                </v-col>
              </template>
              <v-col cols="3">
                <v-text-field
                  label="臨時施設区分"
                  :value="$facility.tempFacilityFlagName(item)"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-checkbox
                  label="安定ヨウ素剤配布場所に設定"
                  :input-value="$facility.lodineDistriPlaceFlgValue(item)"
                  disabled
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="!facilityClass.isShelter()">
              <v-col cols="6">
                <v-text-field
                  :label="$facility.municipalityTitle(item.facility_class)"
                  :value="item.evadist_municip_name"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="item.fa_respons_person"
                  label="施設管理者"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  v-model="item.fa_phone"
                  label="連絡先電話番号"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10">
                <v-text-field
                  v-model="item.fa_mail_address"
                  label="連絡先メールアドレス"
                  v-bind="formControlProps"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  v-model="item.latitude"
                  label="緯度"
                  v-bind="formControlProps"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="item.longitude"
                  label="経度"
                  v-bind="formControlProps"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <v-row v-if="facilityClass.isShelterOrMeeting()">
              <v-col cols="12">
                <eva-area-info
                  :eva-area-info="item.eva_area_info"
                  :read-only="true"
                  :facility-class="item.facility_class"
                  :facility-id="item.fa_id"
                  :municipalities="municipalities"
                  :areas="areas"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" color="primary" @click.native="cancel">
          戻る
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from "vue";
import config from "@/js/const";
import Facility from "@/plugins/facility";
import { FacilityClass } from "@/js/value-objects/facility-class";
Vue.use(Facility);
export default {
  components: {
    EvaAreaInfo: () => import("@/components/facility/EvaAreaInfo")
  },
  data: () => ({
    config: config,
    dialog: false,
    resolve: null,
    reject: null,
    item: [],
    municipalities: [],
    areas: [],
    facilityClass: FacilityClass.factoryShelter()
  }),
  computed: {
    formTitle() {
      return `原子力災害関係施設状況の詳細（${this.facilityClass.name()}）`;
    },
    formControlProps() {
      // 備考欄については直書きしています
      return {
        placeholder: config.PLACEHOLDER_SP,
        disabled: true
      };
    }
  },
  methods: {
    open(item, municipalities, areas) {
      this.dialog = true;
      this.item = item;
      this.municipalities = municipalities;
      this.areas = areas;
      this.facilityClass = FacilityClass.factory(this.item.facility_class);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
    formatDatetime(datetime) {
      if (!datetime) {
        return "";
      }
      const formattedDatetime = this.$moment(datetime, "YYYYMMDDHHmmss");
      if (!formattedDatetime.isValid()) {
        return "";
      }
      return formattedDatetime.format("YYYY/MM/DD HH:mm");
    }
  }
};
</script>

<style scoped>
.border-with-title {
  border: thick solid;
  display: inline-block;
}

.border-title-parent {
  position: relative;
  top: -24px;
  left: 24px;
  height: 24px;
  width: auto;
  z-index: 10;
  display: flex;
}

.border-title {
  font-size: 1.5rem;
  color: rgb(0, 0, 0);
  background: rgb(255, 255, 255);
  padding: 0px 16px;
}
</style>
